import {
  createShallowEqualSelector,
  getColorSelector,
  getSettingValueSelector,
  type SettingsPropsParametricSelector,
  TargetSelector
} from "@client/selectors";

export const makeStyleSelector = (): SettingsPropsParametricSelector => {
  const fontSizeSelector = getSettingValueSelector(TargetSelector.Entity, "size");
  const colorSelector = getColorSelector(TargetSelector.Entity, "color");

  return createShallowEqualSelector(
    [fontSizeSelector, colorSelector],
    (fontSize, color): React.CSSProperties => ({
      color,
      fontSize
    })
  );
};
